import api from "./configuration";
import apiUrl from "./url";
export const CalendarEventsAPI = {
	list: async (params) =>
		(
			await api.request({
				method: "GET",
				url: apiUrl + "/CalendarEvents",
				params,
				useAuthInterceptor: true,
			})
		).data,
};
